import * as React from "react";
import { connect } from "react-redux";
import { withRouter } from 'react-router';
import * as types from "../../constants/actionTypes";
import * as msgs from "../../constants/textConstants";
import * as Tools from "../../helpers/Tools";
import { translateText } from '../../helpers/data';
import { getCityOrZip, getMatchingTerms, getMatchingInsurance } from "../../api/typeaheadApi";
import { logUI } from "../../api/andyliticsApi";
import { Typography } from "../ecosystem/";
import FindCareSearchForm from './FindCareSearchForm';
import FindCareFormTerms from './FindCareFormTerms';
import FindCareFormWrapper from './FindCareFormWrapper';

const USE_CURRENT_LOCATION = 'Current Location';

class FindCareForm extends React.Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            kItems: [],
            keywordLoading: false,
            keywordNoResults: false,
            iItems: [],
            insuranceLoading: false,
            insuranceNoResults: false,
            cItems: [],
            cityZipLoading: false,
            cityZipNoResults: false,
            termsModalOpen: false,
            formOpen: !props.isUrgentCare && this.props.isFormOpen, // Hide the form if its urgent care
            isGeoLocation: true
        };
        this.kTime = 0;
        this.iTime = 0;
        this.cTime = 0;

        this.loadKeywordTypeahead = this.loadKeywordTypeahead.bind(this);
        this.loadInsuranceTypeahead = this.loadInsuranceTypeahead.bind(this);
        this.loadCityZipTypeahead = this.loadCityZipTypeahead.bind(this);
        this.toggleTermsModal = this.toggleTermsModal.bind(this);
        this.toggleForm = this.toggleForm.bind(this);
        this.setCurrentLocationAsCityorZip = this.setCurrentLocationAsCityorZip.bind(this);
        this.onKeywordSelected = this.onKeywordSelected.bind(this);
    }

    componentDidMount() {
        logUI("MBHWeb.UI.FindCareForm.ComponentDidMount", new Date(), Tools.getURLPath());
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.geoLocationError !== undefined && this.props.geoLocationError !== "" && this.props.geoLocationError !== prevProps.geoLocationError) {
            this.setState({ isGeoLocation: this.props.geoLocationError && this.props.isCurrentLocation ? false : true });
        }
        else if (this.props.geoLocationError === "" && this.props.geoLocationError !== prevProps.geoLocationError)
            this.setState({ isGeoLocation: true });
    }

    isACOHaveEligibility(ins) {
        if (ins && this.props.acoAlliance) {
            let acoAlliance = this.props.acoAlliance.split(",");
            let ACOItem = Tools.getACOs().find(a => a.label.toLowerCase() === ins.toLowerCase() && (acoAlliance && acoAlliance.indexOf(a.id) > -1));
            if (ACOItem && ACOItem.label) {
                return true;
            }
        }
        return false;
    }

    loadNetworkCode(model) {
        if (this.props.insurance && this.props.insurance !== null && this.props.insurance !== "") {
            if (this.props.networkCode && this.props.networkCode !== null && this.props.userInsurancePlan &&
                this.props.insurance.toLowerCase() === this.props.userInsurancePlan.toLowerCase()) {
                model.networkCode = this.props.networkCode;
                if (this.props.acoAlliance) model.acoAlliance = this.props.acoAlliance;
            } else {
                if (this.isACOHaveEligibility(this.props.insurance)) {
                    model.acoAlliance = this.props.acoAlliance;
                }
            }
        }
        return model;
    }

    loadKeywordTypeahead(val) {
        this.setState({ kItems: [], keywordLoading: true });
        let dt = new Date();
        const { hasSWHP } = this.props;
        let keywordModel = {
            term: val,
            returnAll: false,
            practiceGroup: hasSWHP ? "SWHP" : ""
        };
        this.loadNetworkCode(keywordModel);
        getMatchingTerms(keywordModel, dt.valueOf())
            .then(json => {
                if (this.kTime < json.timestamp) {
                    this.kTime = json.timestamp;
                    let items = [];
                    let lastCategory = "";
                    json = json.results;
                    if (json) {
                        for (var term in json) {
                            if (json[term].values) {

                                if (json[term].name !== lastCategory) {
                                    lastCategory = json[term].name;
                                    items.push({ id: lastCategory, label: lastCategory, category: lastCategory });
                                }

                                for (var i = 0; i < json[term].values.length; i++) {
                                    var val = json[term].values[i];
                                    items.push({ id: val.searchValue, label: val.searchDisplayName, category: json[term].name, vector: val.searchVector, npi: val.npi ? val.npi : null });
                                }

                                if (json[term].count && json[term].count > json[term].values.length && ["provider", "location"].includes(json[term].values[0].searchVector)) {
                                    const lbl = json[term].count - json[term].values.length;
                                    items.push({ id: `+ more ${items[items.length - 1].vector}`, label: `+ more`, category: json[term].name, vector: items[items.length - 1].vector, loadMore: true });
                                }
                            }
                        }
                    }
                    this.setState({ kItems: items, keywordLoading: false, keywordNoResults: !(items.length > 0) });

                    if (items && items.length > 0) {
                        this.props.setKeywordList(items);
                    }
                }
            });
    }

    loadInsuranceTypeahead(val) {
        if (this.state.insuranceLoading === false) {
            this.setState({ insuranceLoading: true });
            let dt = new Date();
            let insuranceModel = {
                term: val
            };
            this.loadNetworkCode(insuranceModel);
            getMatchingInsurance(insuranceModel, dt.valueOf())
                .then(json => {
                    if (this.iTime < json.timestamp) {
                        this.iTime = json.timestamp;
                        let items = [];
                        let lastCategory = "";
                        json = json.results;
                        if (json) {
                            for (var term in json) {
                                if (json[term].values) {
                                    for (var i = 0; i < json[term].values.length; i++) {
                                        var val = json[term].values[i];
                                        items.push({ id: val.searchValue, label: val.searchDisplayName, category: json[term].name });
                                    }
                                }
                            }
                        }
                        this.setState({ iItems: items, insuranceLoading: false, insuranceNoResults: !(items.length > 0) });
                    }
                });
        }
    }

    loadCityZipTypeahead(val) {
        //if (this.state.cityZipLoading === false) {
        if (val !== "") {
            this.setState({ cityZipLoading: true }, () => {
                let dt = new Date();
                getCityOrZip({ filter: val }, dt.valueOf())
                    .then(json => {
                        if (this.cTime < json.timestamp) {
                            this.cTime = json.timestamp;
                            let items = [];
                            json = json.results;
                            if (json) {
                                for (var term in json) {
                                    items.push({ id: json[term].zip_city, label: json[term].zip_city });
                                }
                            }
                            this.setState({ cItems: items, cityZipLoading: false, cityZipNoResults: !(items.length > 0) });
                        }
                    });
            });
            //}
            //else {
            //    this.setState({ cityZipLoading: false });
            //}
        }
    }

    submitForm(formValid) {
        if (formValid) {
            this.props.searchProvidersAndLocations();
            this.setState({ formOpen: false });
        }
    }

    toggleTermsModal() {
        this.setState({ termsModalOpen: !this.state.termsModalOpen });
    }

    toggleForm() {
        this.setState({ formOpen: !this.state.formOpen }, () => {
            if (this.props.onFormToggle) {
                this.props.onFormToggle(this.state.formOpen);
            }
        });
    }

    setCurrentLocationAsCityorZip() {
        const { getGeoLocation, setCityZip, t, translate } = this.props;
        getGeoLocation(true);
        setCityZip(translateText(t && translate, USE_CURRENT_LOCATION, t));
    }

    onKeywordSelected(val, item, formErrors) {
        const { setVector, setKeyword, searchProviders, searchLocations, keyword, insurance, cityZip } = this.props;
        const formValid = ((keyword || insurance || cityZip) && (!formErrors['insurance']?.value && !formErrors['cityOrZip']?.value));
        setVector(item.vector);

        if (item.npi) {
            // per Jake (#31290): if the selection is a provider, do not run the search; instead, just route directly to the details page.
            this.props.history.push(`/providers/${item.npi}`);
        }
        else if (item.loadMore) {
            setKeyword(keyword);
            if (formValid) {
                if (item.vector === "provider") {
                    searchProviders({ isClearList: true }, { vectorName: item.vector, keyword: keyword + '*' });
                } else if (item.vector === "location") {
                    searchLocations({ isClearList: true }, { vectorName: item.vector, keyword: keyword + '*' });
                }
            }
            this.setState({ formOpen: !this.state.formOpen });
        }
        else {
            setKeyword(item.label);
            //Bug 35177: Find Care - Type Ahead issue for an “invalid” provider in the search results.
            /* if (item.vector === "provider" && formValid) {
                 searchProviders({ isClearList: true }, { vectorName: item.vector, keyword: item.label });
             }*/
        }
    }

    render() {
        const { screenBreakPoint, variant, translate, t } = this.props;
        const isMobile = ([msgs.XS_MOBILE, msgs.SM_MOBILE, msgs.MD_TABLET]).indexOf(screenBreakPoint) > -1 ? true : false;

        let useCurrentLocation = <div className='mybswh-typeahead__use-current-loc-dropdown'><Typography type="body-02" color="$color-primary-a3" bold>{translateText(t && translate, "Use current location", t)}</Typography></div>;
        const isCurrentLocation = (!this.props.currentLat || !this.props.currentLong || this.props.currentLat === null || this.props.currentLong === null) ? false : true;
        let cityZip = this.props.cityZip === USE_CURRENT_LOCATION && isCurrentLocation ? USE_CURRENT_LOCATION : (this.props.cityZip === USE_CURRENT_LOCATION && !isCurrentLocation) ? '' : this.props.cityZip;
        const isGeoCurrentLocationDisabled = this.props.cityZip === USE_CURRENT_LOCATION && (cityZip === '');

        const keyword = (this.props.keyword && this.props.keyword.indexOf("*") > 0) ? this.props.keyword.substr(0, this.props.keyword.indexOf("*")) : this.props.keyword;

        //If we have HP then insuranceplan will always come from parent comp, but still set default value for input valid term 
        const inputValidTerm = this.props.userInsurancePlan ? this.props.userInsurancePlan : "Baylor Scott & White Health Plan";

        return (
            <FindCareFormWrapper
                formOpen={this.state.formOpen}
                toggleForm={() => this.toggleForm()}
                variant={variant}
            >
                <div className="col-12">
                    <FindCareSearchForm
                        borderStyle={this.props.searchSucceeded ? 'flat' : 'elevated'}
                        translate={translate}
                        submitButtonProps={{
                            onClick: () => {
                                logUI("MBHWeb.UI.FindCareForm.SearchButtonClicked", new Date(), Tools.getURLPath());
                                this.props.searchProvidersAndLocations();
                                this.setState({formOpen: false });
                            }
                        }}
                        isValid={(formValues, formErrors) => {
                            let isFormValid = ((this.props.keyword || this.props.insurance || this.props.cityZip) &&
                                (!formErrors['insurance']?.value && !formErrors['cityOrZip']?.value));
                            return isFormValid;
                        }}
                        keywordInputProps={{
                            value: keyword,
                            name: 'careKeyword',
                            loading: this.state.keywordLoading,
                            itemList: this.state.kItems,
                            noResults: this.state.keywordNoResults,
                            autoHighlight: false,
                            onChange: (e, value) => {
                                this.loadKeywordTypeahead(value); this.props.setKeyword(value);
                                this.props.setVector("unified");
                            },
                            onSelect: this.onKeywordSelected,
                            onSubmitForm: (formValid) => this.submitForm(formValid)
                        }}
                        locationInputProps={{
                            value: cityZip,
                            name: 'cityOrZip',
                            loading: this.state.cityZipLoading,
                            selectOnBlur: true,
                            itemList: this.state.cItems,
                            noResults: this.state.cityZipNoResults,
                            onChange: (e, value) => { this.loadCityZipTypeahead(value); this.props.setCityZip(value); },
                            onSelect: (val) => this.props.setCityZip(val),
                            onSubmitForm: (formValid) => this.submitForm(formValid),
                            preOpen: this.state.isGeoLocation ? useCurrentLocation : null,
                            onClickPreOpen: (e) => { this.setCurrentLocationAsCityorZip(e); },
                            inputErrorMsg: "Enter a valid city or zip",
                            geoErrorMsg: (isGeoCurrentLocationDisabled && this.props.geoLocationError && this.props.isCurrentLocation) ? this.props.geoLocationError : '',
                            validTerm: "Current Location",
                        }}
                        insuranceInputProps={{
                            value: this.props.insurance,
                            name: 'insurance',
                            loading: this.state.insuranceLoading,
                            selectOnBlur: true,
                            itemList: this.state.iItems,
                            noResults: this.state.insuranceNoResults,
                            autoHighlight: false,
                            onChange: (e, value) => { this.loadInsuranceTypeahead(value); this.props.setInsurance(value); },
                            onSelect: (val) => this.props.setInsurance(val),
                            onSubmitForm: (formValid) => this.submitForm(formValid),
                            inputErrorMsg: "Select from the drop down.",
                            validTerm: inputValidTerm
                        }}
                    />
                </div>
                <div className="col-12">
                    <FindCareFormTerms
                        isMobile={isMobile}
                        variant={this.props.termsVariant}
                        termsModalOpen={this.state.termsModalOpen}
                        toggleTermsModal={() => this.toggleTermsModal()}
                        translate={translate}
                    />
                </div>
            </FindCareFormWrapper>
        );
    }

}

const mapStateToProps = (state, ownProps) => {
    return {
        searchSucceeded: state.providers.success,
        screenBreakPoint: state.common.screenBreakPoint,
    };
};

export default (connect(mapStateToProps)(FindCareForm));
